/**
 * Banner Scroll
 * Handles smooth scrolling from banner buttons to anchor targets on the page.
 * 
 * Usage (Liquid):
 *   Button:  <a href="#reviews" data-scroll-target="reviews" class="button">...</a>
 *   Target:  {% render 'anchor', anchor_id: 'reviews' %}
 */
class BannerScroll {
  constructor() {
    this.buttons = document.querySelectorAll('[data-scroll-target]');

    if (!this.buttons.length) return;

    this.bind();
  }

  bind() {
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        const targetId = button.getAttribute('data-scroll-target');
        if (!targetId) return;

        const target = document.getElementById(targetId);
        if (!target) {
          console.warn(`[BannerScroll] Target element #${targetId} not found.`);
          return;
        }

        e.preventDefault();
        this.scrollTo(target);
      });
    });
  }

  scrollTo(target) {
    const offset = this.getHeaderOffset();
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top,
      behavior: 'smooth'
    });

    // After scroll completes, move focus to target for keyboard/screen reader users
    const onScrollEnd = () => {
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      window.removeEventListener('scrollend', onScrollEnd);
    };

    if ('onscrollend' in window) {
      window.addEventListener('scrollend', onScrollEnd, { once: true });
    } else {
      // Fallback for browsers without scrollend support
      setTimeout(() => {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }, 600);
    }
  }

  getHeaderOffset() {
    // Read the --header-height CSS variable set by the sticky header component
    const value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseFloat(value) || 0;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new BannerScroll());
} else {
  new BannerScroll();
}
